import React, { useState } from "react";
import {
  Grid,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import { makeStyles } from "@material-ui/styles";
import { ArrowBack, Error } from "@mui/icons-material";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import TaxI2pToSapTable from "./reportTables/TaxI2pToSapTable.js";
const useStyles = makeStyles(dashboardStyle);
const commentBox = {
  fontFamily: "DM Sans,sans-serif",
  fontWeight: "400",
  fontSize: "0.875rem",
  width: "100%",
  border: "1px solid #b4b4b4",
  borderRadius: "2px",
  resize: "none",
  overflow: "hidden",
  outline: "none",
  height: "40px",
  marginTop: "1px",
  color: "black",
};
const headers = [
  { label: "Vendor Code", key: "vendorCode"},
  { label: "Vendor Name", key: "vendorName" },
  { label: "Invoice No", key: "invoiceNo" },
  { label: "Invoice Date", key: "inV_DATE" },
  { label: "Invoice Amount", key: "inV_AMOUNT", align: "right" },
  {label:"Invoice Type", key:"invoiceType"},
  { label: "Sales Tax Input Code", key: "i2PSalesTaxCode", section: "I2P" },
  { label: "Sales Tax Input Amount", key: "i2PSalesTaxAmount", section: "I2P", align: "right" },
  { label: "ITW Code", key: "i2PITWCode", section: "I2P" },
  { label: "ITW Amount", key: "i2PITWAmount", section: "I2P", align: "right" },
  { label: "STW Code", key: "i2PSTWCode", section: "I2P" },
  { label: "STW Amount", key: "i2PSTWAmount", section: "I2P", align: "right" },
  { label: "Sales Tax Input Code", key: "stI_CODE", section: "SAP" },
  { label: "Sales Tax Input Amount", key: "stI_AMT", section: "SAP", align: "right" },
  { label: "ITW Code", key: "itW_CODE", section: "SAP" },
  { label: "ITW Amount", key: "itW_AMT", section: "SAP", align: "right" },
  { label: "STW Code", key: "stW_CODE", section: "SAP" },
  { label: "STW Amount", key: "stW_AMT", section: "SAP", align: "right" },
  { label: "SAP Posting ID", key: "doC_INV", section: "SAP" },
  { label: "Cheque No", key: "chequE_NO", section: "SAP" },
  { label: "Cheque Date", key: "chequE_DATE", section: "SAP" },
];
// const headers = [
//   { label: "Vendor Code", key: "vendorCode" },
//   { label: "Vendor Name", key: "vendorName" },
//   { label: "Invoice No", key: "invoiceNo" },
//   { label: "Invoice Date", key: "invoiceDate" },
//   { label: "Invoice Amount", key: "invoiceAmount" },
//   { label: "Sales Tax Code", key: "salesTaxCode" },
//   { label: "Sales Tax Amount", key: "salesTaxAmount" },
//   { label: "ITW Code", key: "itwCode" },
//   { label: "ITW Amount", key: "itwAmount" },
//   { label: "STW Code", key: "stwCode" },
//   { label: "STW Amount", key: "stwAmount" },
//   { label: "SAP Posting Id", key: "saP_Posting_Id" },
// ];

export default function TaxI2pToSap() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendloader, setSendloader] = useState(false);

  const [countNo, setCountNo] = React.useState(1); // Set default page to 0

  return (
    <div>
      {" "}
      <>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={sendloader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Card style={{ marginLeft: "20px" }}>
          <CardHeader color="primary" text>
            <CardText
              style={{
                padding: "1px 27px",
                backgroundColor: "#031C30",
                color: "white",
                height: "62px",
              }}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <h4>Tax I2p To SAP </h4>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <IconButton
                    variant="contained"
                    style={{ float: "right", marginTop: "1.5%" }}
                    onClick={() => navigate("/home")}
                  >
                    <ArrowBack
                      style={{ color: "#fff" }}
                      titleAccess="Go Back"
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </CardText>
          </CardHeader>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TaxI2pToSapTable
              loading={loading}
              setCountNo={setCountNo}
              header={headers}
              data={data}
              dropdownValue={"InvoiceStatus"}
              setData={setData}
              setLoading={setLoading}
            />
          </Grid>
        </Card>
      </>
    </div>
  );
}
